import React from "react";
import TableFooter from "@mui/material/TableFooter";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { withStyles } from "@mui/styles";
import TablePagination from "@mui/material/TablePagination";
import { useMediaQuery } from "@mui/material";
import theme from "assets/theme";
import breakpoints from "assets/theme/base/breakpoints";
import './styles.css'
import Pagination from "./Pagination";

const defaultFooterStyles = {
  root: {
    [`@media (max-width: ${breakpoints.values.sm}px)`]: {
        flexDirection: 'column'
    },
    '& .MuiToolbar-root':{
      display: 'flex',
    },
    "&:last-child": {
      padding: "0px 0px 0px 0px"
    },
    "& .MuiToolbar-root:last-child":{
        padding: "0px 0px 0px 15px"
    },
    '& .MuiTablePagination-displayedRows':{
      width: '180px',
      textAlign: 'center'
    },
    '& .MuiPagination-ul':{
      flexWrap: 'nowrap'
    },
    '& .MuiPagination-root':{
      padding: "0px 0px 0px 15px",
      width: '100%'
    }
  }
 }

type CustomFooterProps = {
  classes: any;
  count: number;
  page: number;
  rowsPerPage: number;
  onChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onPageChange: (event: any, page: number) => void;
};

const CustomFooter = (props : CustomFooterProps) => {
    const { classes } = props;

    const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
      <TableFooter>
        <TableRow>
          <TableCell>
            <TablePagination
              className={classes.root}
              rowsPerPageOptions={
                smallScreen ? ( [5, 10, 25, { label: "Alle", value: props.count }] ) : ( [5, 10, 25, 50, 100, { label: "Alle", value: props.count }] )
              }
              count={props.count}
              page={props.page}
              rowsPerPage={props.rowsPerPage}
              onPageChange={props.onPageChange}
              onRowsPerPageChange={props.onChangeRowsPerPage}
              ActionsComponent={(subProps) => {
                const {
                  page,
                  count,
                  rowsPerPage,
                  backIconButtonProps,
                  nextIconButtonProps,
                  showLastButton,
                  getItemAriaLabel,
                  showFirstButton,
                  onPageChange,
                  ...restSubProps
                } = subProps;

                return <Pagination
                          rowsPerPage={props.rowsPerPage}
                          count={props.count}
                          currentPageNumber={props.page}
                          paginate={props.onPageChange}
                          />;
              }}
            />
          </TableCell>
        </TableRow>
      </TableFooter>
    );
  }

export default withStyles(defaultFooterStyles, { name: "CustomFooter" })(
  CustomFooter
);